module.exports = __webpack_public_path__ + "img/DK29240175.c10184c1.png";